import { memo, useMemo } from 'react';

import { type PublicClip } from '@air/api';
import { type Clip } from '@air/api/types';

import { AssetVersionThumbnailFileExtensionPreview } from '~/components/v2/components/asset-modal/desktop/versions/asset-version/AssetVersionThumbnailFileExtensionPreview';
import { AssetVersionThumbnailImagePreview } from '~/components/v2/components/asset-modal/desktop/versions/asset-version/AssetVersionThumbnailImagePreview';
import { AssetVersionThumbnailProcessingPreview } from '~/components/v2/components/asset-modal/desktop/versions/asset-version/AssetVersionThumbnailProcessingPreview';
import { getVersionSrc } from '~/components/v2/utils/versions/getVersionSrc';
import { isVersionFilePreview } from '~/components/v2/utils/versions/isVersionFilePreview';

export type AssetVersionThumbnailPreviewProps = {
  version: Clip | PublicClip;
};

export const AssetVersionThumbnailPreview = memo(({ version }: AssetVersionThumbnailPreviewProps) => {
  const isFilePreview = useMemo(() => {
    return isVersionFilePreview(version);
  }, [version]);

  const src = useMemo(() => {
    return getVersionSrc(version);
  }, [version]);

  if (src) {
    return <AssetVersionThumbnailImagePreview src={src} />;
  }

  if (isFilePreview) {
    return <AssetVersionThumbnailFileExtensionPreview ext={version.ext} />;
  }

  return <AssetVersionThumbnailProcessingPreview />;
});

AssetVersionThumbnailPreview.displayName = 'AssetVersionThumbnailPreview';
